// frontend/src/components/onboarding/SourceSurveySession.js
//
// The ONE session marker for the "how did you hear about us" survey: "the
// survey was put on screen this session" (by either surface - the welcome
// dialog's step or the standalone dialog).
//
// Two readers, one key:
//   * GuideContext - so the standalone dialog never asks twice in a session
//     (a failed save leaves `source_survey_due` true until the next login), and
//     so the website / supporter / push / labels promos stand down for the rest
//     of a session the survey took;
//   * GuideContext again, deciding whether a REOPENED welcome may carry the
//     survey step.
//
// Kept out of GuideContext.js itself so the welcome dialog's chunk can write it
// without importing the provider module.

const SOURCE_SURVEY_SHOWN_KEY = "leadify_source_survey_shown_v1";

/**
 * Has the survey already been shown this session?
 *
 * FAILS CLOSED (true on a storage error), the `welcomeShownThisSession` shape:
 * an unreadable sessionStorage must never let a second modal into a session the
 * survey may already have taken.
 *
 * @returns {boolean}
 */
export const sourceSurveyShownThisSession = () => {
  try {
    return sessionStorage.getItem(SOURCE_SURVEY_SHOWN_KEY) === "1";
  } catch {
    return true;
  }
};

/** Record that the survey took this session's modal slot. Best-effort. */
export const markSourceSurveyShown = () => {
  try {
    sessionStorage.setItem(SOURCE_SURVEY_SHOWN_KEY, "1");
  } catch {
    /* the callers' own ref guards still prevent a re-open on this mount */
  }
};

/** Exported for tests only. */
export const __SOURCE_SURVEY_SHOWN_KEY = SOURCE_SURVEY_SHOWN_KEY;
